import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Typography,
  useTheme,
  Tooltip,
  Chip,
  Paper,
} from "@mui/material";
import { Box } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DatagridComponent from "../../datagridComponent";
import useStyles from "./styles";
import GrupoChip from "../../grupoEconomico/GrupoChip";
import dayjs from "dayjs";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import { BusinessOutlined } from "@mui/icons-material";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import RequestPageOutlinedIcon from "@mui/icons-material/RequestPageOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
export default function AccordionVoalle(params) {
  const {
    id,
    nome,
    ownerNome,
    status,
    setSnackbar,
    cpfCnpj,
    dataCadastroContrato,
    dataFimContrato,
    dataInicioContrato,
    dataProximoReajuste,
    diaVencimento,
    filialNome,
    natureFinancer,
    tipoContrato,
    tipoCobranca,
    valor,
    vigenciaMeses,
    contractadress,
    subservicos,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const statusContratoCalc = (dataFimContrato) => {
    const dataFim = dayjs(dataFimContrato, "DD/MM/YYYY");
    const dataAtual = dayjs();

    return dataAtual.isAfter(dataFim) ? "Expirado" : "Em vigência";
  };
  const endereco = [
    contractadress?.street,
    contractadress?.number,
    contractadress?.neighborhood,
    contractadress?.city,
    contractadress?.state,
    contractadress?.cep,
  ]
    .filter(Boolean)
    .join(", ");

  function formatarMoedaBR(input) {
    if (input == null || input === "") return "R$ 0,00";

    if (typeof input === "number") {
      input = Math.round(input * 100).toString();
    }

    let digits = input.toString().replace(/\D/g, "");

    while (digits.length < 3) digits = "0" + digits;

    const cents = digits.slice(-2);
    let integerPart = digits.slice(0, -2);

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return `R$ ${integerPart},${cents}`;
  }

  async function CopyTexto({ campo }) {
    try {
      await navigator.clipboard.writeText(campo);
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = campo;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Falha ao copiar texto: ", err);
      }
      document.body.removeChild(textArea);
    }
    setSnackbar({
      children: "Campo copiado!",
      severity: "info",
    });
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 100,
    },
    { field: "tag", headerName: "Ticket", width: 110 },
    {
      field: "nome",
      headerName: "Nome",
      width: 250,
    },
    {
      field: "endereco",
      headerName: "Endereço",
      width: 450,
    },
    {
      field: "user",
      headerName: "Usuário",
      width: 110,
    },
    { field: "password", headerName: "Senha", width: 110 },
    {
      field: "mac",
      headerName: "MAC",
      width: 130,
    },
    { field: "downloadMax", headerName: "Download", width: 90 },
    { field: "uploadMax", headerName: "Upload", width: 90 },
    { field: "wifiname", headerName: "Wifi nome", width: 100 },
    { field: "wifipassword", headerName: "Wifi senha", width: 100 },
    // {
    // 	field: "link",
    // 	headerName: "",
    // 	sortable: false,
    // 	width: 0.1,
    // 	renderCell: (params) => {
    // 		return (
    // 			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    // 				<Launch sx={{ cursor: "pointer" }} size="small" />
    // 			</Box>
    // 		);
    // 	},
    // },
  ];

  const rows =
    subservicos?.map((sub, index) => {
      const endereco = [
        sub?.adressSubServico?.street,
        sub?.adressSubServico?.number,
        sub?.adressSubServico?.neighborhood,
        sub?.adressSubServico?.city,
        sub?.adressSubServico?.state,
        sub?.adressSubServico?.postalCode,
      ]
        .filter(Boolean)
        .join(", ");

      return {
        id: sub?.idAuthenticationContract || index,
        tag: sub?.tag,
        nome: sub?.nomeSubServico,
        endereco,
        user: sub?.user,
        password: sub?.password,
        mac: sub?.mac,
        downloadMax: sub?.downloadMax,
        uploadMax: sub?.uploadMax,
        wifiname: sub?.wifiname,
        wifipassword: sub?.wifipassword,
      };
    }) || [];

  return (
    <Accordion variant="outlined">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm={8}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Tooltip title={`${id} - ${nome}`}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={styles.summaryTextOverflow}
                >
                  {id} - {nome}
                </Typography>
              </Tooltip>
              {ownerNome && <GrupoChip label={ownerNome} variant="owner" />}
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} sx={styles.accordionTextStatus}>
            <Box
              sx={{
                ...styles.statusDot,
                ...(status === "Normal"
                  ? {
                      bgcolor: theme.palette.colors.green.light,
                    }
                  : {
                      bgcolor: theme.palette.colors.red.light,
                    }),
              }}
            />

            <Tooltip title={status}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={styles.summaryTextOverflow}
              >
                {status}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>
        <Grid container spacing={2} alignItems={"flex-start"}>
          {/*COLUNA 1 */}
          <Grid item xs={12} sm={8}>
            <Grid container spacing={0.2}>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <MonetizationOnOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>Valor:</Typography>

                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: valor })}
                    >
                      {formatarMoedaBR(valor)}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <BusinessOutlined sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Endereço:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: endereco })}
                    >
                      {endereco}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <CorporateFareOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>Filial:</Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: filialNome })}
                    >
                      {filialNome}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <WorkOutlineOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>CNPJ:</Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: cpfCnpj })}
                    >
                      {cpfCnpj}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <DescriptionOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Tipo de Contrato:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: tipoContrato })}
                    >
                      {tipoContrato}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <RequestPageOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Tipo de Cobranca:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: tipoCobranca })}
                    >
                      {tipoCobranca}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <RequestPageOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Natureza financeira:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: natureFinancer })}
                    >
                      {natureFinancer}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/*COLUNA 2 */}
          <Grid item xs={12} sm={4}>
            <Grid container spacing={0.2} alignItems={"flex-start"}>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <EventAvailableOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Vencimento:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: diaVencimento })}
                    >
                      {` Dia ${diaVencimento}`}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <CalendarMonthOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Data de Inicio:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: dataInicioContrato })}
                    >
                      {dataInicioContrato}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <CalendarMonthOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Data de Fim:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: dataFimContrato })}
                    >
                      {dataFimContrato}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <CalendarMonthOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Data proximo reajuste:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: dataProximoReajuste })}
                    >
                      {dataProximoReajuste}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  <CalendarMonthOutlinedIcon sx={styles.icons} />
                  <Typography sx={styles.typhographyTitle}>
                    Data de cadastro:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Typography
                      sx={styles.typographyLabel}
                      onClick={() => CopyTexto({ campo: dataCadastroContrato })}
                    >
                      {dataCadastroContrato}
                    </Typography>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={styles.boxCampos}>
                  {statusContratoCalc(dataFimContrato) === "Expirado" ? (
                    <CancelOutlinedIcon sx={styles.icons} />
                  ) : (
                    <CheckCircleOutlineOutlinedIcon sx={styles.icons} />
                  )}

                  <Typography sx={styles.typhographyTitle}>
                    Status do Contrato:
                  </Typography>
                  <Tooltip title="Clique para copiar">
                    <Chip
                      size="small"
                      label={statusContratoCalc(dataFimContrato)}
                      onClick={() =>
                        CopyTexto({
                          campo: statusContratoCalc(dataFimContrato),
                        })
                      }
                      sx={styles.contratoChip(
                        statusContratoCalc(dataFimContrato) === "Expirado"
                      )}
                    />
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined" sx={{ mt: 2 }}>
          <DatagridComponent columns={columns} rows={rows} />
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
}
